module.exports = __webpack_public_path__ + "static/media/noOrder.2ed7deae.svg";